import { Vue, Component, Watch } from 'vue-property-decorator'
import carritos from '@/store/modules/CarritoModule'
import pedidos from '@/store/modules/PedidoModule'
import articulos from '@/store/modules/ArticuloModule'
import { getEmptyCarritoItem, UnidadMedida, CarritoItem, Articulo }
  from '@/types/types'
import { v4 as uuidv4 } from 'uuid'

@Component
export default class PedidoEditPage extends Vue {
  carrito = carritos.service.getEmpty()
  carritoItem = getEmptyCarritoItem()
  isEdit = false
  headers = [
    {
      text: 'Articulo',
      value: 'articulo.nombre'
    },
    {
      text: 'Cantidad',
      value: 'cantidad'
    },
    {
      text: 'Unidad Medida',
      value: 'unidad_medida.descripcion'
    },
    {
      text: 'Precio',
      value: 'unidad_medida.precio'
    },
    {
      text: 'Importe',
      value: 'sub_total'
    },
    {
      text: '...',
      value: 'actions'
    }

  ]

  openArticulo = false
  search = ''
  loading = false
  unidades: UnidadMedida[] = []

  get title () {
    return this.isEdit ? 'Editar Pedido' : 'Nuevo Pedido'
  }

  @Watch('search')
  onChangeNombre (value: string) {
    if (!value) {
      return
    }
    if (value.length <= 3) {
      return
    }

    if (this.loading) {
      return
    }

    this.loading = true
    articulos.fetchSearchAll(value).finally(() => (this.loading = false))
  }

  get articulos () {
    return articulos.itemsSearch
  }

  addArticulo () {
    this.carritoItem.id = uuidv4()
    this.carritoItem.sub_total = this.carritoItem.cantidad * this.carritoItem.unidad_medida.precio
    this.carrito.items = [
      ...this.carrito.items,
      JSON.parse(JSON.stringify(this.carritoItem))
    ]

    this.openArticulo = false
    this.carritoItem = getEmptyCarritoItem()
  }

  removeArticulo (id: string) {
    this.carrito.items = this.carrito.items.filter(item => id !== item.id)
  }

  onBuscarCliente () {
    carritos.service.getDatosCliente(this.carrito.cliente.documento_identidad).then((response) => {
      if (this.carrito.cliente.documento_identidad.length === 8) {
        this.carrito.cliente.nombre = response.data.nombre + ' ' + response.data.apepat + ' ' + response.data.apemat
      }
    })
  }

  onSelectArticulo (articulo: Articulo) {
    articulos.service.fetchOneRequest(articulo.id).then(response => {
      this.unidades = response.data.data.unidades_medida
    })
  }

  grabarPedido () {
    if (!this.isEdit) {
      this.carrito.id = uuidv4()
      carritos.savePedido(this.carrito).then(() => {
        alert('Pedido Registrado')
        this.$router.push('/pedidos')
      })
    } else {
      carritos.updatePedido(this.carrito).then(() => {
        alert('Pedido Actualizado')
      })
    }
  }

  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.isEdit = true
      pedidos.service.fetchOneRequest(id).then(pedido => {
        this.carrito.id = id
        this.carrito.cliente.nombre = pedido.data.cliente_nombre
        this.carrito.cliente.correo = pedido.data.cliente_correo
        this.carrito.cliente.documento_identidad = pedido.data.cliente_documento
        this.carrito.cliente.telefono = pedido.data.cliente_telefono
        this.carrito.cliente.direccion = pedido.data.cliente_direccion
        pedidos.service.fectchDetailRequest(id).then(response => {
        // eslint-disable-next-line
        response.data.forEach((element: any) => {
            const item: CarritoItem = {
              id: element.id,
              articulo: {
                id: element.articulo_id,
                nombre: element.nombre,
                caracteristicas: '',
                imagen: '',
                hay_stock: '',
                marca: '',
                unidades_medida: []
              },
              cantidad: element.cantidad,
              unidad_medida: {
                id: '',
                descripcion: element.unidad_medida,
                precio: element.precio,
                contenido: element.contenido,
                unidad_contenido: ''
              },
              detalle: element.detalle,
              sub_total: element.cantidad * element.precio

            }
            this.carrito.items = [
              ...this.carrito.items,
              item
            ]
          })
        })
      })
    }
  }
}
